import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid } from 'redux-form'
import { Row, Col, Button } from 'react-bootstrap'
import * as actions from '../../../actions'
import { FORM_RECHAZO_EN_PLAYA } from '../../../../../config/forms'
import MotivosRechazo from '../../../../Forms/SharedComponents/containers/MotivosRechazo'

class Rechazo1 extends Component {
  render () {
    const {
      handleSubmit,
      invalid,
      onPrev,
      showCircular
    } = this.props

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col md={12}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <MotivosRechazo tipo='PLAYA' />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              { !showCircular &&
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button style={{ margin: '2%' }} onClick={() => onPrev()} size='lg'>Cancelar</Button>
                  <Button style={{ margin: '2%' }} type='submit' disabled={invalid} size='lg'>Siguiente</Button>
                </div>
              }
            </Col>
          </Row>
        </form>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_RECHAZO_EN_PLAYA)(state),
  showCircular: state.camionesIngreso.showCircular
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_RECHAZO_EN_PLAYA,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(Rechazo1))
